import React from 'react';
import './Footer.css';
import { FaPhone, FaEnvelope, FaInstagram, FaFacebookF, FaLinkedinIn, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import logo from '../assets/logo.png'; 

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-content">
        {/* Column 1: Logo + Socials */}
        <div className="footer-section logo-section">
          <img src={logo} alt="AtelierbyShriji" className="footer-logo" />
          <div className="footer-icons">
            <a href="https://www.instagram.com/atelierbyshriji?igsh=MWg2dzlqaXZ1ZTRtNw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.facebook.com/share/16WZjPBSbE/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/in/shriji-agarwal-ba414a232?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://youtube.com/@shrijiagarwal?si=ABm8E-yorLkhHyPO" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            <a href="https://wa.me/9310771976" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
          </div>
        </div>

        {/* Column 2: Explore */}
        <div className="footer-section explore-section">
          <div className="footer-heading">
  <h4>Explore</h4>
  <div className="footer-line"></div>
</div>
          <div className="explore-links">
            <div className="column">
              <a href="/bridal-makeup">Bridal Makeup</a>
              <a href="/party-makeup">Party Makeup</a>
              <a href="/editorial-makeup">Editorial Makeup</a>
              <a href="/groom">Groom Makeup</a>
            </div>
            <div className="column">
              <a href="/makeup-courses">Makeup Courses</a>
              <a href="/tutorials">Makeup Tutorials</a>
              <a href="/NoteToBride">Note To Bride</a>
              <a href="/terms-condition">Terms & Conditions</a>
            </div>
          </div>
        </div>

        {/* Column 3: Contact */}
        <div className="footer-section contact-section">
          <div className="footer-heading">
  <h4>Contact Us</h4>
  <div className="footer-line"></div>
</div>
          <div className="contact-links">
  <a href="tel:9310771976"><FaPhone /> +91 9310771976</a>
  <a href="mailto:team@atelierbyshriji.in"><FaEnvelope /> team@atelierbyshriji.in</a>
</div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} AtelierbyShriji 2025. All rights reserved. UDYAM-UP-43-0150122</p>
      </div>
    </footer>
  );
};

export default Footer;
